import { FC } from "react";
import { Link } from "react-router-dom";

import { objectToQueryString } from "src/helpers";
import { StatisticsObjectType } from "../caseVolumeLineChart/types";



const CustomComponentAreaCaseBySubmission: FC<StatisticsObjectType> = ({
  StatisticsObjectType,
  title,
  queryParams,
}): JSX.Element => {
  return (
    <div className="row gx-2">
      <div className="col-12 col-lg-6 mb-3">
        <div className="card">
          <div className="card-header">
            <h1 className="m-0 text-center">RSD
            </h1>
          </div>
          <div className="card-body p-0" style={{maxHeight:'500px', overflow:'auto'}}>
            <table className="table table-responsive table-hover">
              <thead className="table-light sticky-top">
                <tr className="text-center">
                  <th>Name</th>
                  <th>Cases</th>
                </tr>
              </thead>
              <tbody>
                {StatisticsObjectType.rsd &&
                  StatisticsObjectType.rsd.data &&
                  StatisticsObjectType.rsd.data.length > 0 &&
                  StatisticsObjectType.rsd.data.map((item, key) => (
                    <tr className="text-center" key={key}>
                      <td>
                        <Link
                          to={{
                            pathname: `/statistics/${item.id}`,
                            search: objectToQueryString(
                              queryParams
                                ? {
                                    start_date: queryParams.start_date,
                                    end_date: queryParams.end_date,
                                    period: queryParams.period,
                                    filter_type: queryParams.filter_type,
                                    case_filter: queryParams.case_filter,
                                    isdistrictManager:"true"
                                  }
                                : {}
                            ),
                          }}
                          className="fw-normal p-0 btn btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                        >
                          {item.name}
                        </Link>
                      </td>
                      <td>{item.cases || ""}</td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr className="text-center">
                  <td className="fw-bold">Total</td>
                  <td className="fw-bold">{StatisticsObjectType.rsd.total}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      
        <div className="col-12 col-lg-6 mb-3">
          <div className="card">
            <div className="card-header">
              <h1 className="m-0 text-center">TBM</h1>
            </div>
            <div className="card-body p-0" style={{maxHeight:'500px', overflow:'auto'}}>
              <table className="table table-responsive table-hover">
                <thead className="table-light sticky-top">
                  <tr className="text-center">
                    <th>Name	</th>
                    <th>Cases</th>
                    </tr>
              </thead>
              <tbody>
                {StatisticsObjectType.cas &&
                  StatisticsObjectType.cas.data &&
                  StatisticsObjectType.cas.data.length > 0 &&
                  StatisticsObjectType.cas.data.map((item, key) => (
                    <tr className="text-center" key={key}>
                      <td>
                        <Link
                          to={{
                            pathname: `/statistics/${item.id}`,
                            search: objectToQueryString(
                              queryParams
                                ? {
                                    start_date: queryParams.start_date,
                                    end_date: queryParams.end_date,
                                    period: queryParams.period,
                                    filter_type: queryParams.filter_type,
                                    case_filter: queryParams.case_filter,
                                    isdistrictManager:"false"

                                  }
                                : {}
                            ),
                          }}
                          reloadDocument
                          className="fw-normal p-0 btn btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                        >
                          {item.name}
                        </Link>
                      </td>
                      <td>{item.cases || ""}</td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr className="text-center">
                  <td className="fw-bold">Total</td>
                  <td className="fw-bold">{StatisticsObjectType.cas.total}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomComponentAreaCaseBySubmission;
